<template>
  <div class="HomePage">
    <van-nav-bar fixed placeholder>
      <template #right>
        <van-icon name="wap-nav" size="24" color="#000" v-if="!showNavPop" @click="showNavPop = true" />
        <van-icon name="cross" size="24" color="#000" v-else @click="showNavPop = false" />
      </template>
      <template #left>
        <van-image class="menu-item-icon" height="50" v-if="$i18n.locale == 'ja'"
          :src="config.baseURL + $store.getters.getBaseInfo.ico" fit="cover">
        </van-image>
        <van-image class="menu-item-icon" height="50" v-else-if="$i18n.locale == 'ko'"
          :src="config.baseURL + $store.getters.getBaseInfo.ko_ico" fit="cover">
        </van-image>
        <van-image class="menu-item-icon" height="50" v-else :src="config.baseURL + $store.getters.getBaseInfo.en_ico"
          fit="cover">
        </van-image>
      </template>
    </van-nav-bar>
    <div class="HomeMain">
      <div class="TopBox">
        <img src="@/assets/v2/sp_eyecatch01.jpg" alt="">
        <img v-if="$i18n.locale == 'ja'" :src="config.baseURL + $store.getters.getBaseInfo.ico" alt="">
        <img v-else-if="$i18n.locale == 'ko'" :src="config.baseURL + $store.getters.getBaseInfo.ko_ico" alt="">
        <img v-else :src="config.baseURL + $store.getters.getBaseInfo.en_ico" alt="">
      </div>
      <div class="LoginBox" v-if="!token">
        <van-button type="info" block round @click="toPage('/Register')">{{ $t('ljmfks') }}</van-button>
        <div>{{ $t('rgnyzh') }}</div>
        <div style="opacity: 0.4; font-size: 12px;">{{ $t('bfwbxsbsyxkf') }}</div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <img src="@/assets/v2/site_right_arrow.svg" alt="" style="margin-right: 5px;">
          <span>{{ $t('aqkkdppfw') }}</span>
        </div>
      </div>
      <div v-else class="RukouBtn">
        <van-button type="info" color="#d96c62" round @click="toPage('/Lottery?key=game1&id=10')">
          <img src="@/assets/v2/tp.png" alt="" style="height: 25px; margin-right: 5px;">
          {{ $t('tpzx') }}
        </van-button>
        <van-button type="info" round @click="toPage('/Mine')">
          <img src="@/assets/v2/mine.png" alt="" style="height: 25px; margin-right: 5px;">
          {{ $t('grzx') }}
        </van-button>
      </div>
      <div style="padding: 10px;">
        <div style="margin-bottom: 10px; font-size: 16px;">{{ $t('highEndZone') }}
          <i style="background: #3f3a5b; padding: 4px; color: #ebcaaf; font-size: 12px; border-radius: 8px 0 8px 0;">{{
            $t('EnjoyTheUltimateLuxuryExperience') }}</i>
        </div>
        <div style="display: flex; width: 100%; overflow-y: auto; flex-wrap: nowrap;">
          <div class="gdgride" style="margin-right: 5px;" v-for="(v, i) in datalist" :key="i">
            <div v-for="(v2, i2) in v" :key="i2" @click="profile(v2)">
              <van-image :src="v2.img_url" :height="100" :width="100" :radius="8" fit="cover">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
                <template v-slot:error><van-image src="/img/error.png" /></template>
              </van-image>
              <div
                style="position: absolute; bottom: 10px; text-align: center; color: #fff; width: 100%; font-size: 12px;">
                {{ v2.xuanfei_name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 10px;">
        <div style="font-size: 16px;">{{ $t('aboutCannonRecommend') }}</div>
        <div>
          <horizontalItem v-for="(v, i) in datalist2" :key="i" :rowData="v"></horizontalItem>
        </div>
      </div>
      <div class="XqalBox">
        <div>{{ $t('xqaltit') }}</div>
        <div class="XqalList">
          <div v-for="(v, i) in xqalList" :key="i" @click="toDetail(v.id)">
            <van-image :src="v.imgUrl" :height="135" width="100%" fit="cover" :radius="10">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error><van-image src="/img/error.png" /></template>
            </van-image>
            <div class="van-ellipsis">{{ v.title }}</div>
          </div>
        </div>
        <van-button type="info" block round @click="toPage('/Choose')">{{ $t('ckgdxqal') }}</van-button>
      </div>
      <div
        style="background: #1989fa; width: 96%; margin: 0 auto 30px; border-radius: 8px; overflow: hidden; padding-bottom: 10px;">
        <div style="color: #e9b387; text-align: center; padding: 10px 0;">{{ $t('current') }} 1590 {{
          $t('peopleNowMatch')
        }}</div>
        <vue-seamless-scroll :data="listData" :class-option="{
          singleHeight: 18
        }" class="OnlineMatching">
          <ul class="item">
            <li v-for="(item, index) in listData" :key="index">{{ item.title }}</li>
          </ul>
        </vue-seamless-scroll>
      </div>
      <div class="SafeBox">
        <div>{{ $t('syqlaqkkdyy') }}</div>
        <div>{{ $t('syqlaqkkdjtnr') }}</div>
        <div class="SafeList">
          <div>
            <div><img src="@/assets/v2/top_safe01.png" alt=""></div>
            <div>
              <p>{{ $t('safetit011') }}</p>
              <p>{{ $t('safetit012') }}</p>
            </div>
            <div>{{ $t('safecon01') }}</div>
          </div>
          <div>
            <div><img src="@/assets/v2/top_safe02.png" alt=""></div>
            <div>{{ $t('safetit02') }}</div>
            <div>{{ $t('safecon02') }}</div>
          </div>
          <div>
            <div><img src="@/assets/v2/top_safe03.png" alt=""></div>
            <div>{{ $t('safetit03') }}</div>
            <div>{{ $t('safecon03') }}</div>
          </div>
          <div>
            <div><img src="@/assets/v2/top_safe04.png" alt=""></div>
            <div>
              <p>{{ $t('safetit041') }}</p>
              <p>{{ $t('safetit042') }}</p>
            </div>
            <div>{{ $t('safecon04') }}</div>
          </div>
          <div>
            <div><img src="@/assets/v2/top_safe05.png" alt=""></div>
            <div>
              <p>{{ $t('safetit051') }}</p>
              <p>{{ $t('safetit052') }}</p>
            </div>
            <div>{{ $t('safecon05') }}</div>
          </div>
          <div>
            <div><img src="@/assets/v2/top_safe06.png" alt=""></div>
            <div>
              <p>{{ $t('safetit061') }}</p>
              <p>{{ $t('safetit062') }}</p>
            </div>
            <div>{{ $t('safecon06') }}</div>
          </div>
        </div>
      </div>
      <div class="QuestionBox">
        <div>{{ $t('cwwt') }}</div>
        <div class="QuestionList">
          <div>
            <div>
              <img src="@/assets/v2/q_icon.png" alt="">
              <span>{{ $t('q1') }}</span>
            </div>
            <div>
              <img src="@/assets/v2/a_icon.png" alt="">
              <span>{{ $t('a1') }}</span>
            </div>
          </div>
          <div>
            <div>
              <img src="@/assets/v2/q_icon.png" alt="">
              <span>{{ $t('q2') }}</span>
            </div>
            <div>
              <img src="@/assets/v2/a_icon.png" alt="">
              <span>{{ $t('a2') }}</span>
            </div>
          </div>
          <div>
            <div>
              <img src="@/assets/v2/q_icon.png" alt="">
              <span>{{ $t('q3') }}</span>
            </div>
            <div>
              <img src="@/assets/v2/a_icon.png" alt="">
              <span>{{ $store.getters.getBaseInfo.name }} {{ $t('a3') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="MediaBox">
        <div>
          {{ $i18n.locale == 'ja' ? $store.getters.getBaseInfo.name : $i18n.locale == 'ko' ?
            $store.getters.getBaseInfo.ko_name : $store.getters.getBaseInfo.en_name }}
          {{ $t('cbdjmtbd') }}
        </div>
        <div class="MediaList">
          <img src="@/assets/v2/logo_anan.png" alt="">
          <img src="@/assets/v2/logo_mynaviwomen.png" alt="">
          <img src="@/assets/v2/logo_with.png" alt="">
          <img src="@/assets/v2/logo_gisele.png" alt="">
          <img src="@/assets/v2/logo_wbs.png" alt="">
          <img src="@/assets/v2/logo_nikkei.png" alt="">
          <img src="@/assets/v2/logo_asahi.png" alt="">
          <img src="@/assets/v2/logo_sankei.png" alt="">
          <img src="@/assets/v2/logo_jspa.png" alt="">
          <img src="@/assets/v2/logo_tokyoit.png" alt="">
          <img src="@/assets/v2/logo_aera.png" alt="">
          <img src="@/assets/v2/logo_toyo.png" alt="">
        </div>
      </div>
      <div class="KonkatsuBox">
        <div>
          <div>{{ $t('gzhyhhjzc') }}</div>
          <div>{{ $t('wzzcyzgxm') }}</div>
        </div>
        <div class="KonkatsuList">
          <div>
            <img src="@/assets/v2/logo_konkatsu01.png" alt="">
            <div>{{ $t('xm1') }}</div>
          </div>
          <div>
            <img src="@/assets/v2/logo_konkatsu02.png" alt="">
            <div>{{ $t('xm2') }}</div>
          </div>
          <div>
            <img src="@/assets/v2/logo_konkatsu03.png" alt="">
            <div>{{ $t('xm3') }}</div>
          </div>
        </div>
      </div>
      <div class="Certification">
        <div>
          <img src="@/assets/v2/TRUSTe_jp.gif" alt="">
          <img src="@/assets/v2/IMS_logo_200007_4c.gif" alt="">
        </div>
        <!-- <div>
          <div>{{ $t('zxyhfwzch') }}</div>
          <div>{{ $t('slfh') }}</div>
        </div> -->
      </div>
    </div>
    <div class="HddbIcon" v-show="showBackTop" @click="backToTop">
      <img src="@/assets/v2/hddb.png" alt="">
    </div>
    <van-popup v-model="showNavPop" position="bottom" :style="{ height: 'calc(100% - 50px)' }" :overlay="false"
      safe-area-inset-bottom class="NavPop">
      <div class="ItemBox">
        <div @click="toPage('/Lottery?key=game1&id=10')">{{ $t('tpzx') }}</div>
        <div @click="toPage('/Mine')">{{ $t('grzx') }}</div>
        <div @click="toPage('/Choose')">{{ $t('xqaltit') }}</div>
        <div @click="toService">{{ $t('onlineService') }}</div>
        <div @click="toPage('/SwitchLanguage')">{{ $t('switchLanguage') }}</div>
      </div>
      <div class="BtnBox" v-if="!token">
        <van-button type="info" block round @click="toPage('/Login')">{{ $t('login') }}</van-button>
        <van-button block round @click="toPage('/Register')">{{ $t('registerNow') }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import config from "../../http/config";
import horizontalItem from '@/common/horizontalItem.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: "home",
  components: {
    horizontalItem,
    vueSeamlessScroll
  },
  data() {
    return {
      showBackTop: false,
      scrollTop: 0,
      config,
      token: "",
      showNavPop: false,
      xqalList: [],
      datalist: [[]],
      datalist2: [],
      listData: [],
    }
  },
  created() {
    this.token = localStorage.getItem("token") || "";
    for (let i = 0; i < 10; i++) {
      this.listData.push({ title: this.randomWord() + `  ${this.$t('accountMembership')}` })
    }
    // 相亲案例
    this.$http({
      method: 'get',
      url: 'getCaseList',
      data: {}
    }).then(res => {
      console.log("getCaseList", res);
      (res.data || []).map(v => {
        v.imgUrl = this.$config.baseURL + v.imgurl;
      })
      this.xqalList = res.data.slice(0, 4) || [];
    });
    // 妹子
    this.$http({
      method: 'get',
      url: 'xuanfeilist',
      data: {
        id: 1,
        page: 1,
      }
    }).then(res => {
      this.datalist = this.group(res.data, 2);
      this.datalist2 = res.data;
      console.log("xuanfeilist", this.datalist2);
    });
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll() {
      // 获取滚动距离
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 超过 300px 显示
      this.showBackTop = this.scrollTop > 300
    },
    backToTop() {
      // 平滑回到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    toService() {
      if (this.$i18n.locale == "ja") {
        return window.location.href = this.$store.getters.getBaseInfo.kefu;
      } else if (this.$i18n.locale == "ko") {
        return window.location.href = this.$store.getters.getBaseInfo.ko_kefu;
      } else if (this.$i18n.locale == "en") {
        return window.location.href = this.$store.getters.getBaseInfo.en_kefu;
      }
    },
    toPage(path) {
      this.$router.push({ path: path });
      this.showNavPop = false;
    },
    toDetail(id) {
      this.$router.push({
        path: '/caseDetail?id=' + id
      });
    },
    toXF() {
      this.$router.push({
        path: 'Choose'
      });
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },
    profile(v) {
      this.$router.push({
        path: '/profile?id=' + v.id
      });
    },
    randomWord() {
      let arr = [];
      if (this.$i18n.locale == 'ja') {
        arr = ['田中玲奈', '田中葵', '斎藤颯太', '清水真央', '中村遥', '井上翔太', '松本湊', '加藤悠人', '松本美和', '木村悠真',
          '斎藤和也', '井上悠人', '吉田翔太', '清水和也', '橋本花音', '田中さくら', '加藤健太', '清水紗季', '清水愛莉', '井上湊',
          '鈴木玲奈', '田中美和', '中村悠人', '山口結菜', '佐々木海斗', '小林美咲', '佐藤遥', '加藤海斗', '山口和也', '林花子',
          '佐々木紗季', '高橋さくら', '鈴木海斗', '田中愛莉', '小林紗季', '井上和也', '橋本陽翔', '山本真央', '田中詩織', '田中陽翔',
          '小林真央', '林湊', '吉田明日香', '田中直樹', '田中恵', '鈴木心美', '木村悠真', '小林陽翔', '斎藤健一', '山本和也',
          '吉田直樹', '山口悠真', '山口結菜', '小林詩織', '山田隼人', '橋本海斗', '佐藤翔太', '佐藤結菜', '伊藤悠真', '田中明日香',
          '山田花子', '山本紗季', '斎藤優斗', '鈴木健太', '田中颯太', '斎藤和也', '木村花音', '伊藤和也', '佐藤愛莉', '佐藤恵',
          '橋本蓮', '加藤悠人', '吉田優奈', '加藤美優', '佐藤隼人', '斎藤明日香', '橋本海斗', '山田拓海', '佐藤真央', '山田愛莉',
          '山本明日香', '斎藤美和', '中村健一', '清水優斗', '高橋拓海', '田中結菜', '山田葵', '清水直樹', '井上隼人', '林葵',
          '山口玲奈', '山田翔太', '中村遥', '山口優斗', '林結菜', '井上遥', '山口悠人', '松本大翔', '林健一', '山田美和'];
      } else if (this.$i18n.locale == 'ko') {
        arr = [
          "민준", "서준", "도윤", "예준", "시우", "하준", "지호", "주원", "지후", "준서",
          "건우", "현우", "연우", "우진", "선우", "민재", "준우", "시윤", "윤우", "은우",
          "지훈", "수호", "태윤", "유준", "지민", "재윤", "도현", "정우", "승우", "민성",
          "태현", "준혁", "시현", "동현", "성민", "승현", "유찬", "재현", "민규", "지완",
          "태민", "한결", "도훈", "지율", "하율", "서진", "현준", "지성", "준영", "민우",
          "태우", "시완", "윤재", "하진", "정민", "우현", "지섭", "민찬", "재민", "태경",
          "도영", "지혁", "성현", "재훈", "승민", "유진", "동우", "시훈", "현수", "지환",
          "강민", "상우", "도경", "민석", "태호", "준형", "승준", "우성", "시호", "지용",
          "윤성", "정현", "성우", "재성", "지안", "하람", "태준", "도진", "민호", "우빈"
        ];
      } else if (this.$i18n.locale == 'en') {
        arr = [
          "James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Thomas", "Charles",
          "Christopher", "Daniel", "Matthew", "Anthony", "Mark", "Donald", "Steven", "Paul", "Andrew", "Joshua",
          "Kenneth", "Kevin", "Brian", "George", "Edward", "Ronald", "Timothy", "Jason", "Jeffrey", "Ryan",
          "Jacob", "Gary", "Nicholas", "Eric", "Jonathan", "Stephen", "Larry", "Justin", "Scott", "Brandon",
          "Benjamin", "Samuel", "Gregory", "Frank", "Alexander", "Raymond", "Patrick", "Jack", "Dennis", "Jerry",
          "Tyler", "Aaron", "Jose", "Henry", "Adam", "Douglas", "Nathan", "Peter", "Zachary", "Kyle",
          "Walter", "Harold", "Jeremy", "Ethan", "Carl", "Keith", "Roger", "Gerald", "Christian", "Terry",
          "Sean", "Arthur", "Austin", "Noah", "Jesse", "Joe", "Bryan", "Billy", "Jordan", "Albert",
          "Dylan", "Bruce", "Willie", "Gabriel", "Alan", "Juan", "Logan", "Wayne", "Ralph", "Roy",
          "Eugene", "Randy", "Vincent", "Russell", "Louis", "Philip", "Bobby", "Johnny", "Bradley", "Caleb"
        ];
      }
      var index = Math.floor((Math.random() * arr.length));
      return arr[index];
    },
  }
}
</script>

<style lang='less' scoped>
.HomePage {
  .HomeMain {
    padding-bottom: 50px;

    .TopBox {
      position: relative;
      margin-bottom: 10px;

      img {
        width: 100%;
        border-radius: 30px;
        display: block;
      }

      >img:first-child {
        width: 90%;
        margin: 0 auto;
      }

      >img:last-child {
        // margin-bottom: 10px;
        width: 100%;
        position: absolute;
        bottom: 110px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .LoginBox {
      padding: 0 0 10px;
      text-align: center;

      .van-button--block {
        width: 70%;
        height: 100px;
        margin: 0 auto 20px;
      }

      >div {
        margin: 0 auto 20px;
      }
    }

    .RukouBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;

      .van-button {
        width: 50%;
        height: 70px;
        margin: 0 10px;

        .van-button__text {
          display: flex;
          align-items: center;
        }
      }
    }

    .gdgride {
      >div {
        position: relative;
        overflow: hidden;
        border-radius: 8px;

        >span {
          position: absolute;
          z-index: 9;
          background-color: #c35993;
          color: #fff;
          transform: rotate(45deg);
          width: 150px;
          height: 150px;
          font-size: 24px;
          top: -80px;
          right: -80px;

          >i {
            position: absolute;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
            font-weight: bold;
          }
        }
      }
    }

    .XqalBox {
      padding: 40px 15px 0;
      margin-bottom: 60px;

      >div:nth-child(1) {
        font-weight: bold;
        font-size: 40px;
        text-align: center;
        margin-bottom: 50px;
      }

      .XqalList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 60px;
        flex-wrap: wrap;

        >div {
          width: 48.5%;
          margin-bottom: 20px;

          .van-ellipsis {
            color: #A0A0A0;
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }

      .van-button--block {
        width: 70%;
        height: 100px;
        margin: 0 auto;
      }
    }

    .OnlineMatching {
      height: 210px;
      overflow: hidden;


      li {
        text-align: center;
        color: #fff;
        font-size: 28px;
        margin-top: 10px;
      }
    }

    .SafeBox {
      padding: 100px 15px 80px;
      background: #F1FAFF;
      margin-bottom: 20px;

      >div:nth-child(1) {
        font-size: 50px;
        margin-bottom: 20px;
      }

      .SafeList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 14px;

        >div {
          width: 50%;

          img {
            width: 100%;
          }

          >div:nth-child(2) {
            margin-bottom: 10px;
            text-align: center;
            font-weight: bold;

            p {
              margin: 0;
            }
          }

          >div:nth-child(3) {
            font-size: 12px;
          }
        }
      }
    }

    .QuestionBox {
      padding: 100px 15px 30px;
      background: #F1FAFF;

      >div:nth-child(1) {
        font-size: 50px;
        margin-bottom: 60px;
      }

      .QuestionList {
        >div {
          margin-bottom: 40px;
          padding: 20px 40px 20px;
          border-radius: 16px;
          box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);

          >div {
            display: flex;
            align-items: center;
          }

          >div:nth-child(1) {
            font-weight: bold;
          }

          >div:nth-child(2) {
            margin-top: 15px;
            color: #323233;
          }

          img {
            width: 60px;
            height: 60px;
            margin-right: 15px;
          }
        }
      }
    }

    .MediaBox {
      padding: 100px 0 0;

      >div:nth-child(1) {
        font-size: 46px;
        color: #1985E5;
        width: 80%;
        margin: 0 auto 30px;
        text-align: center;
        font-weight: bold;
      }

      .MediaList {
        width: 80%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        >img {
          width: 30%;
          margin-bottom: 10px;
        }
      }
    }

    .KonkatsuBox {
      padding: 100px 0 0;

      >div:nth-child(1) {
        font-weight: bold;
        font-size: 40px;
        text-align: center;
      }

      .KonkatsuList {
        padding: 0 30px;

        >div {
          margin-top: 50px;
          text-align: center;

          >div {
            font-size: 14px;
            text-align: left;
            color: #646566;
            margin-top: 20px;
          }

          img {
            height: 140px;
          }
        }
      }
    }

    .Certification {
      padding: 70px 0 30px;

      >div:nth-child(1) {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-bottom: 50px;

        >img:nth-child(1) {
          height: 70px;
        }

        >img:nth-child(2) {
          height: 110px;
          margin-left: 30px;
        }
      }

      >div:nth-child(2) {
        padding: 0 30px;
        font-size: 12px;
        color: #111111b3;
      }
    }
  }
}

.HddbIcon {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 2000;
  background: #fff;
  border-radius: 50%;

  img {
    width: 80px;
    display: block;
  }
}

.NavPop {
  background: rgba(255, 255, 255, 0.96);

  .ItemBox {
    >div {
      text-align: center;
      height: 80px;
      line-height: 80px;
      padding: 0 15px;
    }
  }

  .BtnBox {
    .van-button--block {
      width: 80%;
      height: 90px;
      margin: 40px auto 0;
    }
  }
}
</style>